import styled from 'styled-components'

export const StyledContainer = styled.div`
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  ${({ theme }) => theme.media.desktop} {
    padding: 0 calc(8.333333%);
    flex-wrap: nowrap;
  }
`
